import React, { Component } from 'react';
import parse from 'html-react-parser';

class IntroV3 extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'

    return  <div className="intro-area mg-top--70">
			  <div className="container">
			    <div className="section-title text-lg-center text-left">
			      <h2 className="title"><span>Travel </span> With Love</h2>
			    </div>
			    <div className="row">
			      <div className="col-lg-3 col-md-6">
			        <div className="single-intro style-two">
			          <div className="thumb">
			            <img src={publicUrl+"assets/img/icons/9.png"} alt="img" />
			          </div>
			          <h4 className="intro-title">Private Transport</h4>
			          <p>Enjoy our private, quick and secured road transport service to our sites in less time</p>
			        </div>
			      </div>
			      <div className="col-lg-3 col-md-6">
			        <div className="single-intro style-two">
			          <div className="thumb">
			            <img src={publicUrl+"assets/img/icons/10.png"} alt="img" />
			          </div>
			          <h4 className="intro-title">Diverse Destinations</h4>
			          <p>Our reach goes beyond The Gambia across West Africa. Wherever you choose to arrive, we can meet you and show you the true diversity of the region in quality, comfort and style.</p>
			        </div>
			      </div>
			      <div className="col-lg-3 col-md-6">
			        <div className="single-intro style-two">
			          <div className="thumb">
			            <img src={publicUrl+"assets/img/icons/11.png"} alt="img" />
			          </div>
			          <h4 className="intro-title">Great Hotels</h4>
			          <p>We offer a wide range of services such as full hotel reservation and admin back up, meet to greet services, inclusive tour packages roundtrips/ multi country tours, conference and incentives packages, worldwide ticketing and cruise handling amongst other services.</p>
			        </div>
			      </div>
			      <div className="col-lg-3 col-md-6">
			        <div className="single-intro style-two">
			          <div className="thumb">
			            <img src={publicUrl+"assets/img/icons/12.png"} alt="img" />
			          </div>
			          <h4 className="intro-title">Tailor-Made Service</h4>
			          <p>Every trip starts as a request, not an instant purchase. Our team reviews it and works with you to adapt the experience to your needs, group and budget before anything is confirmed.</p>
			        </div>
			      </div>
			    </div>
			  </div>
			</div>
        }
}

export default IntroV3